import { useState } from 'react';

export type EditableCardKey = 'user' | 'company' | 'team';

// Ensures only one of the account cards can be in edit mode at a time, and
// exposes the resulting disabled state for the other cards. Team never
// enters edit mode itself (see TeamCard), it only reads isDisabled.
export const useCardEditCoordinator = () => {
  const [activeCard, setActiveCard] = useState<EditableCardKey | null>(null);

  return {
    isEditing: (card: EditableCardKey) => activeCard === card,
    isDisabled: (card: EditableCardKey) => activeCard !== null && activeCard !== card,
    startEditing: (card: EditableCardKey) => setActiveCard(card),
    stopEditing: () => setActiveCard(null),
  };
};
